/*
 *
 * ControlPanelUserManagementAmbassador constants
 *
 */

export const DEFAULT_ACTION =
  "app/ControlPanelUserManagementAmbassador/DEFAULT_ACTION"

  export const GET_LANGUAGE_WATCHER = "app/ControlPanelUserManagementAmbassador/GET_LANGUAGE_WATCHER"
  export const GET_LANGUAGE_SUCCESS = "app/ControlPanelUserManagementAmbassador/GET_LANGUAGE_SUCCESS"
  export const GET_LANGUAGE_FAILED = "app/ControlPanelUserManagementAmbassador/GET_LANGUAGE_FAILED"

export const GET_EMPLOYEES_DIVISIONS_WATCHER =
  "app/ControlPanelUserManagementAmbassador/GET_EMPLOYEES_DIVISIONS_WATCHER"
export const GET_EMPLOYEES_DIVISIONS_SUCCESS =
  "app/ControlPanelUserManagementAmbassador/GET_EMPLOYEES_DIVISIONS_SUCCESS"
export const GET_EMPLOYEES_DIVISIONS_FAILED =
  "app/ControlPanelUserManagementAmbassador/GET_EMPLOYEES_DIVISIONS_FAILED"

export const CREATE_AMBASSADOR_WATCHER =
  "app/ControlPanelUserManagementAmbassador/CREATE_AMBASSADOR_WATCHER"
export const CREATE_AMBASSADOR_SUCCESS =
  "app/ControlPanelUserManagementAmbassador/CREATE_AMBASSADOR_SUCCESS"
export const CREATE_AMBASSADOR_FAILED =
  "app/ControlPanelUserManagementAmbassador/CREATE_AMBASSADOR_FAILED"

export const LIST_AMBASSADORS_WATCHER =
  "app/ControlPanelUserManagementAmbassador/LIST_AMBASSADORS_WATCHER"
export const LIST_AMBASSADORS_SUCCESS =
  "app/ControlPanelUserManagementAmbassador/LIST_AMBASSADORS_SUCCESS"
export const LIST_AMBASSADORS_FAILED =
  "app/ControlPanelUserManagementAmbassador/LIST_AMBASSADORS_FAILED"

export const DELETE_AMBASSADOR_WATCHER =
  "app/ControlPanelUserManagementAmbassador/DELETE_AMBASSADOR_WATCHER"
export const DELETE_AMBASSADOR_SUCCESS =
  "app/ControlPanelUserManagementAmbassador/DELETE_AMBASSADOR_SUCCESS"
export const DELETE_AMBASSADOR_FAILED =
  "app/ControlPanelUserManagementAmbassador/DELETE_AMBASSADOR_FAILED"

export const GET_TEMPLATE_WATCHER =
  "app/ControlPanelUserManagementAmbassador/GET_TEMPLATE_WATCHER"
export const GET_TEMPLATE_FAILED =
  "app/ControlPanelUserManagementAmbassador/GET_TEMPLATE_FAILED"
export const GET_TEMPLATE_SUCCESS =
  "app/ControlPanelUserManagementAmbassador/GET_TEMPLATE_SUCCESS"
